export default __webpack_public_path__ + "static/media/news-02.67022060.jpg";